'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isMonday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isMonday.js
// module id = 236
// module chunks = 1